import axios from "axios"
import { DivisaReadingDtoProps } from "./DTOs/DivisaReadingDto"
import { divisaAdapter } from "./Divisa.adapter"
import { DivisaReadingDtoIPagedEnumerableProps } from "./Schemas/DivisaReadingDtoIPagedEnumerable"

export async function getDivisa() {
  const { data }: Record<"data", DivisaReadingDtoIPagedEnumerableProps> =
    await axios.get("/Divisa")
  return {
    currentPage: data?.currentPage,
    items: data?.items?.map((divisa: DivisaReadingDtoProps) =>
      divisaAdapter(divisa)
    ),
    totalCount: data?.totalCount,
  }
}
